import AppListing from '../app-components/Listing/AppListing';

Vue.component('app-file-location-listing', {
    mixins: [AppListing],
    emits: ['onselected-file', 'tab-upload-content'],
    methods:{
        setSelectedFile(data){
            console.log('data', data)
            this.$emit('onselected-file', data)
        }
    }
});